import React from 'react'

import { ButtonProps } from '@mui/material'

import { Button } from '../../utils/shared/Button'
import { Loader } from '../loader/loader'

import * as S from './submit-button.styles'

type Props = Omit<ButtonProps, 'size' | 'fullWidth'> & { loading: boolean }

export const SubmitButton = ({ children, loading, ...props }: Props) => (
  <Button fullWidth {...props} disabled={loading || props.disabled}>
    <S.Content>
      {children}
      {loading && <Loader size="xs" />}
    </S.Content>
  </Button>
)
